<template>
  <div v-if='!divisions'>
    <wc-loading msg='Loading division'></wc-loading>
  </div>
  <div v-else>
    <wc-page-title :title="division.division + ' Division'"></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='division'
            :division='division'
            @update='udpate'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <div-details
            v-if='division'
            :division='division'
            @update='udpate'
          ></div-details>
        </v-col>
        <v-col cols='12' md='4'>
          <div-contact-details
            v-if='division'
            :division='division'
            @update='udpate'
          ></div-contact-details>
        </v-col>
        <v-col cols='12' md='4'>
          <wo-types
            v-if='division'
            :division='division'
          ></wo-types>
        </v-col>
        <v-col cols='12' md='4'>
          <timesheet-categories
            v-if='division'
            :division='division'
          ></timesheet-categories>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import settingsAPI from '../../api/settings'
import WOTypes from './WOTypes'
import Basics from './Basics'
import Details from './Details'
import ContactDetails from './ContactDetails'
import TimesheetCategories from './TimesheetCategories'

export default {
  name: 'divisions-all',
  computed: {
    iconData () {
      return this.$store.state.icons.dataBox.divisions
    },
    divisions () {
      return this.$store.state.misc.divisions
    },
    division () {
      let divID = parseInt(this.$route.params.id)
      return this.divisions.find(d => d.id === divID)
    }
  },
  methods: {
    udpate (div) {
      // Don't forget to update the store on update
      this.$store.dispatch('replaceDivision', div)
      settingsAPI.updateDivision(div)
    }
  },
  components: {
    'basics': Basics,
    'wo-types': WOTypes,
    'div-details': Details,
    'div-contact-details': ContactDetails,
    'timesheet-categories': TimesheetCategories
  }
}
</script>
